module.exports = __webpack_public_path__ + "img/slider_galery_27.b346a848.jpg";